/**
 * Cierres de mes: publicación a residentes solo tras aprobación admin.
 * - payments / expensesapartments: publishedToResidents === false → oculto a residentes.
 * - Sin campo (datos legacy) → visible (comportamiento histórico).
 */

export function isPaymentPublishedToResidents(p) {
  return p?.publishedToResidents !== false;
}

export function filterPaymentsVisibleToResidents(payments) {
  if (!Array.isArray(payments)) return [];
  return payments.filter(isPaymentPublishedToResidents);
}

export function isExpenseApartmentPublishedToResidents(ea) {
  return ea?.publishedToResidents !== false;
}

/** montlyaccount: sin approvalStatus o 'approved' → considerado publicado a nivel UI legacy */
export function isCierreApproved(ma) {
  if (!ma) return true;
  const s = ma.approvalStatus;
  if (s === "pending") return false;
  return true;
}
